{
  "header": {
    "welcomeMessage": "¡Bienvenido, {{firstName}}!",
    "description": "Revisa y analiza las respuestas anteriores de retroalimentación"
  },
  "emptyState": {
    "company": {
      "title": "No se han recopilado datos aún",
      "description": "¡Tu viaje comienza aquí! Una vez que los empleados empiecen a compartir sus opiniones durante el primer mes, verás aparecer conocimientos y tendencias"
    },
    "directReports": {
      "title": "Sin subordinados directos",
      "description": "No tienes subordinados directos asignados, ¡pero aún puedes participar en encuestas y compartir comentarios valiosos!",
      "bottomAction": {
        "label": "Si crees que esto es un error, contacta con tu gerente",
        "helpText": "Texto de ayuda"
      }
    }
  },
  "tabs": {
    "company": "Toda la empresa",
    "allReports": "Todos los informes",
    "directReports": "Informes directos",
    "myTeam": "Mi equipo"
  },
  "keysInsights": {
    "title": "Principales ideas",
    "strengths": {
      "title": "Fortalezas",
      "tooltipTitle": "Texto de ayuda"
    },
    "growthAreas": {
      "title": "Áreas de crecimiento",
      "tooltipTitle": "Texto de ayuda"
    }
  },
  "enps": {
    "title": "eNPS",
    "chart": {
      "description": "El eNPS mide la probabilidad de que los empleados recomienden su lugar de trabajo, reflejando el compromiso y la satisfacción generales"
    },
    "scoreTitle": "Tu equipo",
    "companyAverageTitle": "eNPS de la empresa"
  },
  "overview": {
    "title": "Resumen",
    "scoreTitle": "Tu equipo",
    "companyAverageTitle": "Promedio de la empresa"
  }
}
